import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AuthenticationService } from '../../service/authentication/authentication.service';
import { User } from './../../model/user';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalAlertService } from '../../modules/modals/alert-window';

@Component({
    selector: 'modal-envia-email-component',
    template: '',
})
export class ModalEnviaEmailService {
    bsModalRef: BsModalRef;
    constructor(private modalService: BsModalService) { }

    show(title: string, message: string) {
        const initialState = {
            title: title,
            message: message
        };
        this.bsModalRef = this.modalService.show(ModalEnviaEmailComponent, { initialState });
        this.bsModalRef.content.closeBtnName = 'Close';
    }
}

@Component({
    selector: 'modal-content',
    template: `<div class="modal-header">
                <h4 class="modal-title text-center">{{title}}</h4>
                </div>
                <div class="modal-body text-center">
                <p>{{message}}</p>
                <form  #f="ngForm" novalidate>
                <div class="form-group" [formGroup]="recuperaSenhaFormGroup">
                <input       
                            type="email"
                            required
                            class="form-control"
                            [(ngModel)]="user.email"
                            name="email"
                            formControlName="email"
                            id="emailRecurepa"
                            placeholder="Digite o seu E-mail">
                </div>
                </form>
                <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!recuperaSenhaFormGroup.valid">OK</button>
                </div>
                    `})

export class ModalEnviaEmailComponent {

    recuperaSenhaFormGroup: FormGroup;
    user: User = new User();

    constructor(public bsModalRef: BsModalRef,
        private authenticationService: AuthenticationService,
        private formBuilder: FormBuilder,
        private alertModalService: ModalAlertService
    ) {
        let emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
        this.recuperaSenhaFormGroup = this.formBuilder.group({
            email: ['', [Validators.required, Validators.pattern(emailPattern)]]
        });

    }

    confirm() {
        this.authenticationService.recuperaSenha(this.user).subscribe(res => {
            this.bsModalRef.hide();
            this.alertModalService
            .show("Atenção", res["mensagemRetorno"]);
        });



    }
}
